// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMFilterBar.tsx — PropelMapper filter / toolbar bar.
//
// A search field on the left, a row of filter triggers in the middle, and an
// optional actions slot on the right (children). Below it, removable active-
// filter chips. Composes PMMenu + PMChip conceptually but renders standalone so
// the consumer just passes config. All --pm-* tokens.

const PMFBAR_CSS = `
.pmfbar{box-sizing:border-box;font-family:var(--pm-font-sans)}
.pmfbar-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.pmfbar-search{position:relative;flex:1 1 240px;min-width:200px;max-width:400px}
.pmfbar-search-ic{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:var(--pm-fg-3);pointer-events:none}
.pmfbar-search input{box-sizing:border-box;width:100%;border:1px solid var(--pm-border);background:var(--pm-surface);border-radius:var(--pm-radius-pill,999px);min-height:42px;padding:0 16px 0 40px;font:var(--pm-body-m);color:var(--pm-fg-1);outline:none;font-family:inherit}
.pmfbar-search input:focus{border-color:var(--pm-primary);box-shadow:var(--pm-focus-ring)}
.pmfbar-actions{margin-left:auto;display:flex;align-items:center;gap:10px}
.pmfbar-chips{display:flex;align-items:center;gap:9px;flex-wrap:wrap;margin-top:13px}
.pmfbar-chips-lbl{font:var(--pm-label-m);font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:var(--pm-fg-3)}
.pmfbar-clear{background:none;border:none;font:var(--pm-label-l);font-weight:600;color:var(--pm-primary);cursor:pointer;font-family:inherit;padding:4px 6px;border-radius:6px}
.pmfbar-clear:hover{text-decoration:underline}
`;
function pmfbarEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmfbar-css")) return;
  const s = document.createElement("style"); s.id = "pmfbar-css"; s.textContent = PMFBAR_CSS;
  document.head.appendChild(s);
}

const pmfbarGlyphVars: any = { "--icon-fg": "currentColor", "--icon-accent": "currentColor" };
function pmfbarGlyph(base, size, cls = "") {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base] ? base : (I[base + "-outline"] ? base + "-outline" : null);
  if (name) return <span className={"pm-icon " + cls} aria-hidden="true"
    style={Object.assign({ width: size, height: size }, pmfbarGlyphVars)}
    dangerouslySetInnerHTML={{ __html: I[name] }} />;
  return <span className={"material-symbols-outlined " + cls} aria-hidden="true"
    style={{ fontSize: size, lineHeight: 1 }}>{base}</span>;
}

export function PMFilterBar({
  search,
  searchPlaceholder = "Search…",
  onSearch,
  filters = [],
  activeChips = [],
  onRemoveChip,
  onClearAll,
  searchable,
  className = "",
  style = {},
  children,
  ...rest
}) {
  pmfbarEnsureCSS();
  const NS = (typeof window !== "undefined" && window.PropelMapperNativeDesignSystem_ed538a) || {};
  const PMMenu = NS.PMMenu;
  const PMChip = NS.PMChip;
  return (
    <div className={"pmfbar" + (className ? " " + className : "")} style={style} {...rest}>
      <div className="pmfbar-row">
        {onSearch || search !== undefined ? (
          <div className="pmfbar-search">
            {pmfbarGlyph("search-outline", 20, "pmfbar-search-ic")}
            <input value={search || ""} placeholder={searchPlaceholder}
              onChange={(e) => onSearch && onSearch(e.target.value)} />
          </div>
        ) : null}
        {filters.map((f, i) =>
          PMMenu ? (
            <PMMenu key={f.key || i} label={f.label} icon={f.icon} options={f.options}
              value={f.value} multi={f.multi} searchable={f.searchable}
              onChange={(v) => f.onChange && f.onChange(v)} />
          ) : null
        )}
        {children != null ? <div className="pmfbar-actions">{children}</div> : null}
      </div>
      {activeChips.length ? (
        <div className="pmfbar-chips">
          <span className="pmfbar-chips-lbl">Filters</span>
          {activeChips.map((c, i) =>
            PMChip ? (
              <PMChip key={c.key || i} label={c.label} dotColor={c.dotColor}
                onRemove={() => onRemoveChip && onRemoveChip(c, i)} />
            ) : null
          )}
          {onClearAll ? <button type="button" className="pmfbar-clear" onClick={onClearAll}>Clear all</button> : null}
        </div>
      ) : null}
    </div>
  );
}
